import { getItemLocalStorage } from './getItemLocalStorage.js';

const hasDireito = (direito) => {
    const direitos = getItemLocalStorage('direitos');
    if (!direitos) {
        return false;
    }
    return !!direitos.find(item => item === direito);
};

export { hasDireito };
